import { Box, Checkbox, ListItemIcon, Stack, Typography } from '@mui/material'
import { CarrierVisitStatus } from '@operations/app/api'
import { CarrierVisitStatusChip } from '@operations/components/chips/CarrierVisitStatusChip'
import { formatDate } from 'modules/ui/src/theme/components/table/utils/tom-table.utils'

interface Props {
  name: string
  status: CarrierVisitStatus
  renderProps: any
  rotationNumber?: string | null
  date?: string | null
  showCheckbox?: boolean
  isSelected?: boolean
}
export const CarrierVisitOption = ({
  name,
  status,
  renderProps,
  rotationNumber,
  date,
  showCheckbox,
  isSelected,
}: Props) => {
  return (
    <Box {...renderProps} component='li' data-cy={`carrier-visit-option-${name}`}>
      {showCheckbox && (
        <ListItemIcon>
          <Checkbox edge='start' checked={isSelected} disableRipple />
        </ListItemIcon>
      )}
      <Stack flexDirection='row' gap={theme => theme.customSpacing.m}>
        <CarrierVisitStatusChip status={status} />
        {rotationNumber && <Typography variant='body1'>{rotationNumber}</Typography>}

        <Typography variant='body1'>{name}</Typography>

        {date && <Typography variant='body1'>{formatDate(date)}</Typography>}
      </Stack>
    </Box>
  )
}
